var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmojiSad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Emoji"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33 16.5C33 25.6126 25.6126 33 16.5 33C7.38833 33 0 25.6126 0 16.5C0 7.38833 7.38833 0 16.5 0C25.6126 0 33 7.38833 33 16.5Z",
    fill: "#FED97C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5417 16.4997C11.8073 16.4997 12.8333 15.0633 12.8333 13.2913C12.8333 11.5194 11.8073 10.083 10.5417 10.083C9.27601 10.083 8.25 11.5194 8.25 13.2913C8.25 15.0633 9.27601 16.4997 10.5417 16.4997Z",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.4635 16.4997C23.7292 16.4997 24.7552 15.0633 24.7552 13.2913C24.7552 11.5194 23.7292 10.083 22.4635 10.083C21.1979 10.083 20.1719 11.5194 20.1719 13.2913C20.1719 15.0633 21.1979 16.4997 22.4635 16.4997Z",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.94845 25.5478C8.11162 25.6953 8.35545 25.7045 8.53053 25.5743C8.56628 25.5478 12.1257 22.916 16.5055 22.916C20.8744 22.916 24.4457 25.5478 24.4805 25.5743C24.6556 25.7045 24.8994 25.6935 25.0626 25.5478C25.2249 25.4011 25.2615 25.1591 25.1488 24.9721C25.0305 24.7759 22.1999 20.166 16.5055 20.166C10.8112 20.166 7.97962 24.775 7.86228 24.9721C7.74953 25.16 7.78528 25.4011 7.94845 25.5478Z",
    fill: "#664500"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSad);
export default __webpack_public_path__ + "static/media/emoji-sad.4643627836b4c14fbfc37dbfa3a9a6bb.svg";
export { ForwardRef as ReactComponent };